import { useQuery } from 'react-query'

import { QueryNames } from 'Hooks/api/queryNames'
import { useErrorReporter } from 'Hooks/useErrorReporter'

import { getRecurringAllowances } from 'Services/recurringAllowances'
import { GetRecurringAllowancesPayload } from 'Services/apiResponseTypes'

export const useGetRecurringAllowancesQuery = (payload: GetRecurringAllowancesPayload) => {
  const reportError = useErrorReporter()
  const { userId, benefitProgramId, perPage, pageNumber } = payload

  return useQuery({
    cacheTime: 1,
    queryKey: [
      QueryNames.GetUserRecurringAllowances,
      userId,
      benefitProgramId,
      perPage,
      pageNumber
    ],
    queryFn: async () => {
      const response = await getRecurringAllowances(payload)

      if (response.data) {
        return response.data
      } else {
        reportError('useGetUserRecurringAllowancesQuery failure', response)
      }
    }
  })
}
